export const formatAddress = (account: string, isLong?: boolean) => {
  if (!account) return '';
  const first = account.substring(0, isLong ? 8 : 6);
  const last = account.substring(account.length - (isLong ? 8 : 4));
  return `${first}...${last}`;
};

export const formateAddressInTableCell = (account: string) => {
  if (!account) return '';
  const first = account.substring(0, 21);
  return `${first}...`;
};
